'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { useIsMobile } from '@/hooks/useBreakpoints';
import { CuratorVaultsTableFilters } from '../components';
import CuratorVaultsTableRowsSkeleton from './CuratorVaultsTableRowsSkeleton';
interface CuratorVaultsTableSkeletonProps {
  withFilters?: boolean;
  withPagination?: boolean;
  withHeader?: boolean;
  rows?: number;
}
const CuratorVaultsTableSkeleton = t0 => {
  const $ = _c(19);
  const {
    withFilters: t1,
    withPagination: t2,
    withHeader: t3,
    rows: t4
  } = t0;
  const withFilters = t1 === undefined ? true : t1;
  const withPagination = t2 === undefined ? true : t2;
  const withHeader = t3 === undefined ? true : t3;
  const rows = t4 === undefined ? 10 : t4;
  const isMobile = useIsMobile();
  let t5;
  if ($[0] !== withFilters) {
    t5 = withFilters && <CuratorVaultsTableFilters disabled={true} filters={{
      assets: [],
      search: ""
    }} onFiltersChange={_temp} withNetworkFilter={true} withGlobalSearch={false} assetOptions={{
      items: [],
      partial: false
    }} />;
    $[0] = withFilters;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== isMobile || $[3] !== withHeader) {
    t6 = withHeader && !isMobile && <div className="mb-[10px] flex"><Skeleton className="h-[40px] w-[100%] rounded-[20px]" /></div>;
    $[2] = isMobile;
    $[3] = withHeader;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = withPagination ? "0" : "16px";
  let t8;
  if ($[5] !== t7) {
    t8 = {
      marginBottom: t7
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== rows || $[8] !== t8) {
    t9 = <CuratorVaultsTableRowsSkeleton rows={rows} style={t8} />;
    $[7] = rows;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== withPagination) {
    t10 = withPagination && <div className="gap-sm mt-md flex items-center justify-center"><Skeleton className="h-lg w-8 rounded-[20px]" /><Skeleton className="h-md w-[30px] rounded-[20px]" /><Skeleton className="h-lg w-8 rounded-[20px]" /></div>;
    $[10] = withPagination;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t6 || $[14] !== t9) {
    t11 = <div className="flex flex-col">{t6}{t9}{t10}</div>;
    $[12] = t10;
    $[13] = t6;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t5) {
    t12 = <div data-testid="curator-vaults-table-skeleton" className="gap-md flex flex-col">{t5}{t11}</div>;
    $[16] = t11;
    $[17] = t5;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
export default CuratorVaultsTableSkeleton;
function _temp() {}